import { render, staticRenderFns } from "./form-verification-modal.vue?vue&type=template&id=6daf6b6e&scoped=true&"
import script from "./form-verification-modal.vue?vue&type=script&lang=js&"
export * from "./form-verification-modal.vue?vue&type=script&lang=js&"
import style0 from "./form-verification-modal.vue?vue&type=style&index=0&id=6daf6b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daf6b6e",
  null
  
)

component.options.__file = "form-verification-modal.vue"
export default component.exports